import { GET_PROJECT_ALTERNATES } from "constants/projectAlternates";

export default (state = [], action) => {
  switch (action.type) {
    case `${GET_PROJECT_ALTERNATES}_SUCCESS`:
      return action.payload;
    default:
      return state;
  }
};
